import React, {useEffect, useState} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';
import {useTranslation} from 'react-i18next';
import {Switch} from '../../buttons/Swtich';
import {VISIBILITY} from './factConstants';

const MAX_NOTE_LENGTH = 5000;

// Modal para crear o editar una nota (ClientMemory). En creación incluye el toggle de
// compartir con el cliente; en edición sólo el texto (la visibilidad se cambia desde la lista).
export function NoteEditModal({isOpen, note, saving, toggle, onSave}) {
    const {t} = useTranslation();
    const isCreate = !note;
    const [text, setText] = useState('');
    const [shared, setShared] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setText(note ? note.text || '' : '');
            setShared(note ? note.visibility === VISIBILITY.SHARED : false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, note ? note.id : null]);

    const trimmed = text.trim();
    const valid = trimmed.length > 0 && trimmed.length <= MAX_NOTE_LENGTH;

    const handleSave = () => {
        const payload = {text: trimmed};
        if (isCreate) payload.visibility = shared ? VISIBILITY.SHARED : VISIBILITY.AGENCY_ONLY;
        onSave(note, payload);
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                {isCreate ? t('client_memory.notes.create_title') : t('client_memory.notes.edit_title')}
            </ModalHeader>
            <ModalBody>
                <div className="modal-section">
                    <div className="form-row">
                        <label>{t('client_memory.notes.text_label')}</label>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={text}
                            maxLength={MAX_NOTE_LENGTH}
                            placeholder={t('client_memory.notes.text_placeholder')}
                            onChange={(e) => setText(e.target.value)}
                        />
                        <span className="cmem-char-count">{`${trimmed.length}/${MAX_NOTE_LENGTH}`}</span>
                    </div>
                    {isCreate && (
                        <div className="form-row">
                            <label className="cmem-share-toggle">
                                <Switch name="note-share" checked={shared}
                                        onChange={(e) => setShared(e.target.checked)} style={{margin: 0}}/>
                                <span>{t('client_memory.visibility.share')}</span>
                            </label>
                        </div>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle} disabled={saving}>
                    {t('client_memory.action.cancel')}
                </Button>
                <button type="button" className="btn -alt" disabled={!valid || saving} onClick={handleSave}>
                    {t('client_memory.action.save')}
                </button>
            </ModalFooter>
        </Modal>
    );
}
